import { action, makeObservable } from 'mobx';
import { WindowState } from '../../components/overlays/windowState';
import { Message, StoreNode, StoreNodeProps } from '../../store';
import { Store } from '../../store/store';

export class CancelAccountWindowState
  extends StoreNode {
  readonly nodeType = 'CancelAccountWindow';
  constructor(store: Store, props?: StoreNodeProps) {
    super(store, props);
    makeObservable(this, {
      open: action,
      close: action,
    });
    this.window.listen(
      this.windowListener);
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close('close');
        break;
    }
  }
  readonly window = new WindowState(this.store);

  open() {
    this.dispatch('Overlays', 'openWindow', { name: 'CancelAccountWindow' });
    this.emit('open');
  }

  async close(msg?: string) {
    this.dispatch('Overlays', 'closeWindow');
    if (msg) this.emit(msg);
  }
}